<script setup>
  const props = defineProps({
    photoSize: Number,
    profile: { required: true, type: Object },
    row: Boolean,
    small: Boolean,
    extraSmall: Boolean,
    titleSize: {
      type: String,
      default: 'lg'
    }
  })

  const photoSize = props.photoSize ?? (props.extraSmall ? 12 : props.small ? 20 : 32)
</script>

<template>
  <div
    class="flex flex-col items-center justify-center space-y-2"
    :class="{
      'sm:flex-row sm:space-x-4 sm:space-y-0': row
    }"
  >
    <div class="relative">
      <div
        class="rounded-full bg-zinc-300 bg-cover bg-center"
        :class="`h-${photoSize} w-${photoSize}`"
        :style="{
          backgroundImage: profile.photo ? `url('${profile.photo}')` : undefined
        }"
      />
      <NuxtLink
        class="absolute flex"
        v-if="profile.linkedin"
        :class="small || extraSmall ? 'bottom-0 right-0' : 'bottom-1 right-1'"
        target="_blank"
        :to="`https://www.linkedin.com/${
          profile.linkedin.startsWith('in/') || profile.linkedin.startsWith('company/') ? profile.linkedin : 'in/' + profile.linkedin
        }`"
      >
        <FontAwesomeLayers :class="{
          'text-2xl': !small && !extraSmall,
          'text-xl': small,
          'text-xs': extraSmall
          }">
          <FontAwesomeIcon class="text-linkedin" icon="fa-solid fa-square" />
          <FontAwesomeIcon class="text-white" icon="fa-brands fa-linkedin-in" transform="shrink-6" />
        </FontAwesomeLayers>
      </NuxtLink>
    </div>
    <div
      v-if="profile.name || profile.title"
      class="text-center text-lg font-bold"
      :class="{
        'sm:text-left': row,
      }"
    >
      <div class="font-special capitalize text-viking-400" v-if="profile.name" v-text="profile.name" />
      <div v-if="profile.title" v-text="profile.title" :class="`text-${titleSize}`" />
    </div>
  </div>
</template>
